import api from "./api";

async function getCardPayout(id) {
  try {
    const response = await api.get(`api/cardpayouts/${id}`);
    return response.data;
  } catch (error) {
    return [];
  }
}

export {
  getCardPayout
};
